import { useTranslation } from "react-i18next";
import { RootState } from "../../store/root-reducer";
import { connect } from "react-redux";
import { MiniPlanCard } from "../../components/PlanCard";
import FieldBlock from "../../components/CreateAce2Claim/FieldBlock";

function ReviewClaim({ claim, plan }) {
  const { claim_items: claimItems = [], customer_data: customerData = {} } =
    claim;
  const { t } = useTranslation();
  return (
    <div className="space-y-6">
      <MiniPlanCard plan={plan} />
      <div>
        <div className="bg-[#F3F8FE] bg-opacity-80 min-h-8  p-4 border-border-gray  border  gap-2 overflow-hidden rounded-lg">
          <div className="text-black font-semibold  block">
            {t("Customer information")}
          </div>
          <div className="space-y-2 mt-2">
            <FieldBlock label="Email" value={customerData?.email} />
            <FieldBlock label="Phone" value={customerData?.phone} />
            <FieldBlock label="Address 1" value={customerData?.address1} />
            <FieldBlock label="Address 2" value={customerData?.address2} />
            <FieldBlock label="City" value={customerData?.city} />
            <FieldBlock label="State" value={customerData?.state} />
            <FieldBlock label="Zip" value={customerData?.zip} />
          </div>
        </div>
      </div>
      {claimItems.map((item, idx) => (
        <div key={item.id}>
          <div className="bg-[#EBEEEF] min-h-8 rounded flex items-center px-2 gap-2 overflow-hidden">
            <span className="size-5 flex justify-center items-center  bg-white rounded-full p-3">
              {idx + 1}
            </span>
            <div className="text-black font-semibold  block">
              {item?.warrantyItem?.name || item?.name || ""}
            </div>
          </div>
          <div className="bg-white grid gap-1.5 divide-y-[1px] divide-[#F0F0F0] px-2 py-2">
            <FieldBlock label="Manufacturer" value={item?.manufacturer} />
            <FieldBlock label="Material" value={item?.material} />
            <FieldBlock label="Color" value={item?.color} />
            <FieldBlock label="Vendor" value={item?.warrantyItem?.vendor} />
          </div>
          <div className="space-y-3">
            {item?.damages?.map((damage, idx) => (
              <div
                className="border-l-4 border-l-[#2D6CCA] ps-2"
                key={damage?.id}
              >
                <div className="text-black font-semibold overflow-hidden">
                  {t("Damage")} {idx + 1}
                </div>
                <div className="space-y-1 divide-y">
                  <FieldBlock
                    label="Damage Category"
                    value={damage?.damageCategory}
                  />
                  <FieldBlock
                    label="Specific Damage"
                    value={damage?.specificDamage}
                  />
                  <FieldBlock
                    label="Damage Area"
                    value={damage?.specificLocation}
                  />
                  <FieldBlock
                    label="When did you notice the damage"
                    value={damage?.damageDate}
                    date
                  />
                  <FieldBlock
                    label="How did it happen"
                    value={damage?.occuredReason}
                  />
                  <FieldBlock
                    label="Did you take any steps to remedy"
                    value={damage?.actionTaken}
                  />
                  <FieldBlock label="Note" value={damage?.notes} />
                </div>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
}

const mapStateToProps = (state: RootState) => ({
  claim: state?.ace2Claim || {},
  plan: state?.ace2Claim?.plan || {},
});

export default connect(mapStateToProps)(ReviewClaim);
